import { useDetailedDropById } from 'pages/Drops/useDetailedDropById'
import { useResponsiveRowBuilder } from 'sharedComponents/ProductStream/helpers'
import RowBuilder from 'uiComponents/molecules/TileGrid/RowBuilder'

const PRODUCT_ID_REGEXP = /["']id["']:(.*?),/g

// TODO: add tests for this hook
export const useProductIdsForResponsiveRowBuilder = (
  rowBuilder: RowBuilder,
) => {
  const detailedDropById = useDetailedDropById()

  useResponsiveRowBuilder(rowBuilder)

  if (!detailedDropById) {
    return undefined
  }

  const firstBatchProductIds = detailedDropById?.products
    .map(product => {
      try {
        return JSON.parse(product)
      } catch (e) {
        // try to extract id from string if JSON is corrupted
        const exec = PRODUCT_ID_REGEXP.exec(product)

        if (exec !== null) {
          return exec[1]
        }
      }

      return ''
    })
    .map(product => product.id)

  if (firstBatchProductIds) {
    rowBuilder.resetTiles(
      firstBatchProductIds.map(id => ({ id, type: 'product' })),
    )
  }
}
